import { InfoMessage } from 'components';
import { validΤurnoverNm } from 'utils';

export const content = () =>
  [
    {
      label: '1. Δικαιολογητικό/αποδεικτικό νόμιμου εκπροσώπου του Δικαιούχου Φορέα',
      fileCode: 'benProofLegalRepr',
      id: 'benProofLegalRepr',
      fileLimit: 100,
      required: true,
    },
    {
      label: '2. Στοιχεία Αρμοδιότητας του υποψήφιου Δικαιούχου για την Αίτηση Ένταξης',
      fileCode: 'benDetailsCompetency', 
      id: 'benDetailsCompetency', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '3. Έγγραφα Ιδιοκτησιακού Καθεστώτος αντλητικού ή αντλητικών συγκροτημάτων',
      fileCode: 'benOwnershipStatusPumping', 
      id: 'benOwnershipStatusPumping', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '4. Νομιμοποιητικά Έγγραφα αντλητικών συγκροτημάτων',
      fileCode: 'benLegitimationPumpingUnits', 
      id: 'benLegitimationPumpingUnits', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '5. Τεχνική Μελέτη (προτεινόμενων παρεμβάσεων)',
      fileCode: 'benTechnicalStudyInterv', 
      id: 'benTechnicalStudyInterv',
      fileLimit: 100,
      required: true,
    },
    {
      label: '6. Απόφαση του αρμόδιου οργάνου για την Αίτηση Ένταξης',
      fileCode: 'benDecInclusionApp',
      id: 'benDecInclusionApp', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '7. Τελευταία Έκθεση Ενεργειακού Ελέγχου (Α’ ενεργειακός έλεγχος)',
      fileCode: 'benLatestEnergyReport',
      id: 'benLatestEnergyReport',
      fileLimit: 100,
      required: true,
    },
    {
      label: '8. Έκθεση Σκοπιμότητας',
      fileCode: 'benFeasibilityReport',
      id: 'benFeasibilityReport',
      fileLimit: 100,
      required: true,
    },
    {
      label: '9. Χρονοδιάγραμμα Υλοποίησης',
      fileCode: 'benImplementationSchedule',
      id: 'benImplementationSchedule',
      fileLimit: 100,
      required: true,
    },
    {
      label: '10. Τεύχη Δημοπράτησης',
      fileCode: 'benTenderIssues', 
      id: 'benTenderIssues', 
      fileLimit: 100,
    },
    {
      label: '11. Βεβαίωση – Δήλωση ανάληψης λειτουργίας και συντήρησης του έργου',
      fileCode: 'benDeclarationCommissioning', 
      id: 'benDeclarationCommissioning', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '12. Εγκριτικές αποφάσεις μελετών',
      fileCode: 'benApprovingDecisionsStudies', 
      id: 'benApprovingDecisionsStudies',
      fileLimit: 100,
      required: true,
    },
    {
      label: '13. Πίνακας αποτύπωσης Υποστηρικτικών Μελετών και Ωρίμανσης',
      fileCode: 'benSupportStudiesMaturation', 
      id: 'benSupportStudiesMaturation', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '14. Πίνακας αποτύπωσης Αδειών και Εγκρίσεων',
      fileCode: 'benLicensesApprovals', 
      id: 'benLicensesApprovals', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '15. Στοιχεία για τη Διοικητική και Επιχειρησιακή επάρκεια του υποψήφιου Δικαιούχου',
      fileCode: 'benDetailsOperationalProsp', 
      id: 'benDetailsOperationalProsp',
      fileLimit: 100,
      required: true,
    },
    {
      label: '16. Στοιχεία για τη Χρηματοοικονομική Ικανότητα του υποψήφιου Δικαιούχου',
      fileCode: 'benDetailsFinancialCapacity',
      id: 'benDetailsFinancialCapacity', 
      fileLimit: 100,
      required: true,
    },
    {
      label: '17. Περιγραφή ομάδας έργου και τεκμηρίωση εμπειρίας σε συναφή έργα',
      fileCode: 'benProjectTeamDescr', 
      id: 'benProjectTeamDescr',
      fileLimit: 100,
      required: true,
    },
    {
      label: '18. Υπεύθυνες δηλώσεις του Φορέα σύμφωνα με την παράγραφο 1.9.2 του παρόντος οδηγού (Κρατικές Ενισχύσεις)',
      fileCode: 'benStateAidsDeclar', 
      id: 'benStateAidsDeclar',
      fileLimit: 100,
      required: true,
    },
    {
      label: '19. Μισθωτήριο/παραχωρητήριο σε περίπτωση που το αντλητικό συγκρότημα είναι μισθωμένο',
      fileCode: 'benLeasePump', 
      id: 'benLeasePump',
      fileLimit: 100,
      required: false,
    },
    {
      label: '20. Σχετική Απόφαση κήρυξης Δήμου σε κατάσταση εκτάκτου ανάγκης λόγω λειψυδρίας από την Γενική Γραμματεία Πολιτικής Προστασίας (αν υφίσταται)',
      fileCode: 'benEmergencyState', 
      id: 'benEmergencyState',
      fileLimit: 100,
      required: false,
    },
    {
      label: '21. Λοιπά Έγγραφα',
      fileCode: 'benOtherDocs', 
      id: 'benOtherDocs',
      fileLimit: 100,
      required: false,
    },
  ].filter(item => item);
